import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const CellExpenseClient = ({ client = "" }) => {
    return (
        <Flex>
            <ClientName content={client} />
        </Flex>
    );
};

export default CellExpenseClient;

const ClientName = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
